import type { ReactNode } from 'react'
import './PageHeader.css'

interface PageHeaderProps {
  title: string
  actions?: ReactNode
}

// Shared by the Leagues tab and the Gameweek tab so titles match in weight,
// scale, and centering. Gameweek-specific chrome (countdown,
// progress dots, points row) stays in GameweekGrid, rendered alongside this.
function PageHeader({ title, actions }: PageHeaderProps) {
  return (
    <div className="page-header">
      <p className="page-header__title">{title}</p>
      {actions && <div className="page-header__actions">{actions}</div>}
    </div>
  )
}

export default PageHeader
